document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    function updateScrollbarClickPosition(swiper) {
      const scrollbar = document.querySelector(".swiper-scrollbar");
  
      if (!scrollbar) return;
  
      scrollbar.addEventListener("click", function (event) {
        const rect = scrollbar.getBoundingClientRect();
        const clickX = event.clientX - rect.left;
        const scrollRatio = clickX / rect.width;
        const maxIndex = swiper.slides.length - swiper.params.slidesPerView;
  
        swiper.slideTo(Math.round(maxIndex * scrollRatio));
      });
    }
    const swiperContainer = document.querySelector(".swiper-container");

    if (!swiperContainer) {
      console.error("Swiper container not found!");
      return;
    }

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      loop: true,
      loopAdditionalSlides: 5,
      loopFillGroupWithBlank: true,
      grabCursor: false,
      centeredSlides: false,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        768: { slidesPerView: 2.5 },
        1024: { slidesPerView: 2.5 },
      }
    });

    updateScrollbarClickPosition(swiper);

    swiper.on("init", () => {
      swiper.update();
      swiper.scrollbar.updateSize();
    });
  
    swiper.update();
    swiper.scrollbar.updateSize();

  }, 500);
});
